/**
 * Basic events that are emitted by filter-button
 */
export var FilterEvent;
(function (FilterEvent) {
    FilterEvent["Input"] = "input";
    FilterEvent["FilterUpdated"] = "filter-updated";
    FilterEvent["FilterReset"] = "reset-filter";
})(FilterEvent || (FilterEvent = {}));
